/**
 * Deep Q, intermission 1: three butterflies flit in cells under slime taps. Run under the stones
 * above the taps and each drips through onto its butterfly: a drip can only fall while the
 * butterfly is at the bottom of its cell, so it never misses (docs/spec/03 §3).
 */

import type { CaveDef } from '../types';

export const deepQ: CaveDef = {
  id: 'Q',
  name: 'DRIP FEED',
  hint: 'Run under the stones; the drips will find the butterflies.',
  intermission: true,
  colors: [6, 3, 1],
  diamondValue: 20,
  extraValue: 30,
  fill: { base: '.', items: [['d', 10]] },
  levels: [
    { seed: 6701, diamonds: 8, time: 40 },
    { seed: 6702, diamonds: 9, time: 38 },
    { seed: 6703, diamonds: 10, time: 36 },
    { seed: 6704, diamonds: 11, time: 34 },
    { seed: 6705, diamonds: 12, time: 32 },
  ],
  map: [
    'WWWWWWWWWWWWWWWWWWWW',
    'W..????????????????W',
    'W....r....d....r...W',
    'WP.................W',
    'W...wsw..wsw..wsw..W',
    'W...w w..w w..w w..W',
    'W...wbw..wbw..wbw..W',
    'W...www..www..www..W',
    'W??????????????????W',
    'W.d??????????????d.W',
    'W???????????????.X.W',
    'WWWWWWWWWWWWWWWWWWWW',
  ],
};
